export const AIMode = Object.freeze({
    listening: "listening",
    speaking: "speaking",
});

export const toAIMode = (value) => {
    const key = value.toLowerCase();
    return AIMode[key] || value;
};